import React, { useState, useEffect } from "react";
import { push } from "connected-react-router";
import { reducerType } from "redux/reducers";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import HeaderBarSub from "components/HeaderBarSub";
import Container from "@material-ui/core/Container";
import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "./styles";
import GridFullHeight from "components/GridFullHeight";
import GridFormContainer from "components/GridFormContainer";
import {
  GET_SERVICES_REDUCER,
  LOADMORE_SERVICES_REQUEST,
  DELETE_SERVICE_REQUEST,
} from "redux/reducers/service/actionTypes";
import { SORT, DIRECTION, LIMIT, SKIP } from "common/utils";
import { useSelector } from "react-redux";
import Loading from "components/Loading";
import MSService from "containers/MSServiceContainer";
import { ServiceProps } from "common/";
import Alert from "components/Alert";
import { UserRole } from "common/";
import { useTranslation } from "react-i18next";

const commonQuery = {
  sort: SORT,
  direction: DIRECTION,
  limit: LIMIT,
  skip: SKIP,
  isShowAll: false,
  // filter: 'isApproved',
  // isApproved: 'true | false',
};

interface ManageServicesProps {
  dispatch: Dispatch;
  loading: boolean;
  services: ServiceProps[];
  loadingMore: boolean;
  canLoadmore: boolean;
}

const mapStateToProps = (state: reducerType) => {
  return {
    loading: state.service.loading,
    services: state.service.data,
    loadingMore: state.service.loadingMore,
    canLoadmore: state.service.canLoadmore,
  };
};

const ManageServices = React.memo((props: ManageServicesProps) => {
  const { dispatch, loading, services, loadingMore, canLoadmore } = props;
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedService, setSelectedService] = useState();
  const classes = styles();
  const translate = useTranslation().t;

  const openUrl = (url) => {
    dispatch(push(url));
  };
  const current_user = useSelector(
    (state: reducerType) => state.auth.current_user
  );

  const handleWindowScroll = () => {
    const bottomOfWindow =
      window.scrollY + window.innerHeight >= document.body.scrollHeight - 500;
    if (bottomOfWindow && !loadingMore && canLoadmore) {
      loadmoreServices();
    }
    return;
  };

  useEffect(() => {
    window.addEventListener("scroll", handleWindowScroll);
    return () => {
      window.removeEventListener("scroll", handleWindowScroll);
    };
  });

  const applyNearestToMeParams = (
    params: Record<string, unknown>
  ): Record<string, unknown> => {
    const next = { ...params };
    if (params.sort !== "nearestToMe") return next;
    const currentLocation = sessionStorage.getItem("@shelter_current_location");
    if (!currentLocation || currentLocation === "undefined") return next;
    try {
      const { longitude, latitude } = JSON.parse(currentLocation);
      (next as Record<
        string,
        unknown
      >).nearCoordinate = `${longitude}|${latitude}`;
      (next as Record<
        string,
        unknown
      >).currentCoordinate = `${longitude}|${latitude}`;
    } catch (_) { }
    return next;
  };
  useEffect(() => {
    const initialObj = { ...commonQuery } as Record<string, unknown>;

    // Case 1: Volunteer, VolunteerSenior
    if ([UserRole.Volunteer, UserRole.VolunteerSenior].includes(current_user.role)) {
      // initialObj.filter = "user,userType";
      // initialObj.user = current_user.id;
      // initialObj.userType = "volunteer";
      initialObj.filter = "user";
      initialObj.user = current_user.id;
    }
    // Case 2: Admin, VolunteerLead
    else if ([UserRole.Administrator, UserRole.VolunteerLead].includes(current_user.role)) {
      initialObj.filter = "isShowAll";
      initialObj.isShowAll = true;
    }
    // Case 3: User
    else {
      initialObj.filter = "user,isShowAll";
      initialObj.user = current_user.id;
      initialObj.isShowAll = true;
    }

    dispatch({
      type: GET_SERVICES_REDUCER,
      params: applyNearestToMeParams(initialObj),
      pageSize: LIMIT,
      defaultQuery: true,
    });
    // eslint-disable-next-line
  }, []);

  const onDelete = (id) => {
    dispatch({
      type: DELETE_SERVICE_REQUEST,
      id: id,
    });
  };

  const loadmoreServices = () => {
    dispatch({
      type: LOADMORE_SERVICES_REQUEST,
      defaultQuery: true,
      pageSize: LIMIT,
    });
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setSelectedService(null);
  };

  const handleOpenAlert = (id) => {
    setOpenAlert(true);
    setSelectedService(id);
  };

  const handleClickYes = () => {
    selectedService && onDelete(selectedService);
    handleCloseAlert();
  };

  return (
    <GridFullHeight container>
      <GridFormContainer item xs={12} sm={12} md={12}>
        <GridFullHeight container>
          <HeaderBarSub
            backUrl={"/"}
            openUrl={openUrl}
            name={translate("MANAGE_SERVICES")}
            isSearch
          />

          <Container className={classes.root}>
            {loading ? (
              <Loading />
            ) : (
              <>
                {services && services.length > 0 ? (
                  services.map((data, index) => (
                    <MSService
                      handleOpenAlert={handleOpenAlert}
                      data={data}
                      key={index}
                      onDelete={onDelete}
                      openUrl={openUrl}
                      userRole={current_user.role}
                    />
                  ))
                ) : (
                  <p className={classes.noText}>
                    {translate("NO_SERVICES_BEFORE")}{" "}
                    <a href="/add_service">{translate("ADD_SERVICE")}</a>{" "}
                    {translate("NO_SERVICES_AFTER")}
                  </p>
                )}
                {canLoadmore && (
                  <Container className={classes.textCenter}>
                    <CircularProgress
                      style={{ width: 25, height: 25 }}
                      className={classes.loadmore}
                    />
                  </Container>
                )}
                <Alert
                  title={translate("DELETE_SERVICE_CONFIRM")}
                  open={openAlert}
                  handleClose={handleCloseAlert}
                  handleClickYes={handleClickYes}
                />
              </>
            )}
          </Container>
        </GridFullHeight>
      </GridFormContainer>
    </GridFullHeight>
  );
});

export default connect(mapStateToProps)(ManageServices);
